import { useMe } from 'data/hooks/useMe';
import { useAuth } from 'data/context/AuthContext';
import testingVar from 'utils/testingVar';
import { useCannon } from 'data/hooks/useCannon';
import { useClarityIdentify } from 'data/hooks/useClarity';

export const useConnect = () => {
  const { onSwitchAccount, logout } = useAuth();
  const { me } = useMe({ keepPreviousData: true });
  const { cannon } = useCannon('sidebar');
  const isTesting = testingVar('');

  useClarityIdentify(me);

  return { isTesting, onSwitchAccount, logout, me, cannon };
};
